import React from 'react';

import {
  FormikDropdownField,
  FormikTextField,
  FormikToggleField,
} from '@components/FormikFields';

import type { QuestionnaireItemModel } from 'generated/types';

interface QuestionnaireFieldProps {
  question: QuestionnaireItemModel;
  formName?: string;
}

/**
 *  Dynamic component used to render FHIR Questionnaire resource items
 */
export default function QuestionnaireField({
  question,
  formName,
}: QuestionnaireFieldProps) {
  const { linkId, required: isRequired, text, type } = question;
  const required = isRequired ?? false;
  const label = text ?? undefined;
  const name = formName ?? linkId;

  switch (type) {
    case 'boolean':
      return <FormikToggleField headerLabel={label} name={name} />;
    case 'choice':
      // eslint-disable-next-line no-case-declarations
      const options = (question.answerOption ?? []).reduce<
        { k: string; v: string }[]
      >((acc, curr) => {
        const option = curr.valueCoding?.code;
        if (option) {
          acc.push({
            k: option,
            v: option,
          });
        }
        return acc;
      }, []);

      return (
        <FormikDropdownField
          label={label}
          name={name}
          options={options}
          required={required}
        />
      );
    case 'string':
      return (
        <FormikTextField
          name={name}
          label={label}
          charLimit={255}
          required={required}
        />
      );
    default:
      return null;
  }
}
